import axios from "axios";
import Vue from "vue";
import store from "@/store";
import router from "@/router";

import { apiBaseUrl } from "@/environment/environment";

/**
 * Axios basic configuration
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
const config = {
  baseURL: apiBaseUrl
};

/**
 * Creating the instance of Axios
 * It is because, in large scale application we may need to consume APIs from more than single server,
 * So, may need to create multiple http client with different config
 * Only this client will be used rather than axios in the application
 **/
const httpClient = axios.create(config);

/**
 * Auth interceptors
 * @description Configuration related to AUTH token can be done in interceptors.
 * Currenlty it is just doing nothing but idea to to show the capability of axios and its interceptors
 * In future, interceptors can be created into separate files and consumed into multiple http clients
 * @param {*} config
 */
const authInterceptor = config => {
  /** add auth token */
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;

  return config;
};

const loggerInterceptor = config => {
  /** Add logging here */
  console.log(
    "%c " + config.method.toUpperCase() + " - " + config.url + ":",
    "color: #0086b3; font-weight: bold",
    config
  );

  return config;
};

/** Adding the request interceptors */
httpClient.interceptors.request.use(authInterceptor);
httpClient.interceptors.request.use(loggerInterceptor);

/** Adding the response interceptors */
httpClient.interceptors.response.use(
  response => response,
  async error => {
    if (error && error.response) {
      // HTTP 401 interceptor
      if (error.response.status === 401) {
        if (
          error.response.message === "Token has expired" ||
          error.response.message === "Wrong number of segments"
        ) {
          Vue.notify({
            group: "main",
            type: "error",
            title: "Session expirée",
            duration: 5000
          });
        } else {
          Vue.notify({
            group: "main",
            type: "error",
            title: "Identifiants invalide",
            duration: 5000
          });
        }

        store.dispatch("auth/logout");

        router.push({ name: "LoginPage" });
      }
    }
  }
);

export { httpClient };
